import * as core from '../../../../../../../core'
import * as attainSpecKit from '../attain-spec-kit'

export const RESOURCE = {
  payload: {
    alias: 'traceability-matrix',
    appAlias: attainSpecKit.RESOURCE.payload.alias,
    description:
      'See how every requirement traces to its pull requests, tests, review, and docs',
    display: {
      isMain: true,
      position: 7,
    },
    name: 'Traceability Matrix',
    page: { alias: 'traceability-matrix' },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
